import { assetBundleSoundMusic } from "../../assetBundles/assetBundleSoundMusic";
import { assetBundleSoundSound } from "../../assetBundles/assetBundleSoundSound";
import { IdSoundGroup } from "../../utils/sound/IdSoundGroup";
import { utilSound } from "../../utils/sound/utilSound";
import { soundEventConfig } from "./soundEventConfig";
import { soundSpriteConfig } from "./soundSpriteConfig";
export var configureSound = function () {
    utilSound.registerSounds(IdSoundGroup.Music, assetBundleSoundMusic[utilSound.supportedCodec], soundSpriteConfig);
    utilSound.registerSounds(IdSoundGroup.Sound, assetBundleSoundSound[utilSound.supportedCodec], soundSpriteConfig);
    utilSound.setEventConfig(soundEventConfig);
};



//////////////////
// WEBPACK FOOTER
// ./src/setup/sound/configureSound.ts
// module id = 2513
// module chunks = 3